import { useEffect, useState } from "react";

const WORDS = ["shipping", "writing", "building", "thinking", "scaling"];
const ROTATION_INTERVAL_MS = 2600;

export default function RotatingWord() {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(
      () => setI((p) => (p + 1) % WORDS.length),
      ROTATION_INTERVAL_MS
    );
    return () => clearInterval(t);
  }, []);

  return (
    <span className="word-swap" data-testid="hero-rotating-word">
      <span key={WORDS[i]} className="word-anim text-accent">
        {WORDS[i]}
      </span>
    </span>
  );
}
